export function getGlobal(val) {
	const globals = window.globals || {}
	return globals[val]
}
